export class Mcplanningmaterial {
}

export class FinalRequirementDetails {
    requirementDetailsID:any;
    jobNumber:string;
    rmhName:string;
    rmhID:string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string
    requirementType:string
    requestedQuantity:any;
    orderStatus:any;
    availableinInventory:any;
    finalQuantity:any;
    approvedQuantity:any;
    approvedQuantityCopy:any;
    unitPrice:any;
    deliveryDeadline:any;
    quarter:any;
    brandManager:any;
    portfolio:any;
    ma:any;
    actions:any;
    status:any;
    isApprovedQuantityUpdated:any;
    isActive:boolean;
    rollingyear:any;
}
export class RequirementDetailsZMH {
    requirementDetailsID:any;
    jobNumber:string;
    rmhName:string;
    rmhID:string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string
    requirementType:string
    requestedQuantity:any;
    orderStatus:any;
    availableinInventory:any;
    finalQuantity:any;
    approvedQuantity:any;
    approvedQuantityCopy:any;
    unitPrice:any;
    deliveryDeadline:any;
    quarter:any;
    brandManager:any;
    portfolio:any;
    ma:any;
    actions:any;
    status:any;
    isApprovedQuantityUpdated:any;
    isActive:boolean;
    isDisable:boolean;
}
export class RequirementDetails {
    requirementDetailsID:any;
    jobNumber:string;
    rmhName:string;
    rmhID:string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string
    requirementType:string
    requestedQuantity:any;
    orderStatus:any;
    availableinInventory:any;
    finalQuantity:any;
    approvedQuantity:any;
    approvedQuantityCopy:any;
    unitPrice:any;
    deliveryDeadline:any;
    quarter:any;
    brandManager:any;
    portfolio:any;
    ma:any;
    actions:any;
    status:any;
    isApprovedQuantityUpdated:any;
    isActive:boolean;
    isDisable:boolean;
    Remarks:any;
    cancelledQty:any=null;
}
export class FinalRequirementFilters {
    jobNumbers:jobNumber[];
    rmhs:RMH[];
    jobTypes:JobType[];
    brands:Brand[];
    crops:Crop[];
    languages:Language[];
    requirementTypes:RequirementType[];
    status:RequirementStatus[];
    bms:BM[];
    mas:MA[];
    states:State[];
    year:Year[];
    maMapping:MaMapping[];
    bmMapping:BmMapping[];
    mapping : stateMapping[];
}

export class MaMapping{
    rMHCode:string;
    state:string;
    ma:string;
}

export class stateMapping{
    languageID : number;
    languageName : string;
    state : string;
}

export class BmMapping{
    brandName:string;
    bmName:string;
}

export class jobNumber{
    jobNumberID:string;
    jobNumberName:string;
}
export class RMH{
    rMHCode:string;
    rMHName:string;
}

export class Brand{
    brandID:string;
    brandName:string;
}

export class JobType{
    jobTypeID:number;
    jobTypeName:string;
}

export class RequirementType{
    requirementTypeID:number;
    requirementTypeName:string;
}

export class Crop{
    cropID:number;
    cropName:string;
}

export class Language{
    languageID:number;
    languageName:string;
}

export class RequirementStatus{
    requirementStatusID:number;
    requirementStatusName:string;
}

export class BM{
    bmCode:string;
    bmName:string;
}

export class MA{
    maCode:string;
    maName:string;
}

export class ApprovedQuantity{
    RequirementDetailID:string;
    Quantity:string;
    IsChanged:any;
    RequirementType: string;
}
export class State{
    stateID:string;
    stateName:string;
}
export class Year{
    year:string;
    currentrequirementYear:string;
}

